module.exports = __webpack_public_path__ + "SourceSansPro-Bold.5c6c404eca1aa7c5951e.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/erikh/GitHub/Brickchain/oidc-demo/frontend/src/assets/fonts/SourceSansPro-Bold.ttf
// module id = ../../../../../src/assets/fonts/SourceSansPro-Bold.ttf
// module chunks = styles